<template>
    <div class="background-circle-4">
        <svg width="1440" height="635" viewBox="0 0 1440 635" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.11" x="-287.5" width="2015" height="2015" rx="1007.5" fill="#CBD5FB"/>
        </svg>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.background-circle-4 {
    display: flex;
    justify-content: center;

    svg {
        width: 100%;
    }
}
</style>
